export default __webpack_public_path__ + "static/media/hero_title_three_mobile.e565cf85.svg";